import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from '../../indi-customer';
import { InvoiceDetailsForm } from '../../form-controls';

@Component({
  selector: 'app-new-salesorder-invoice-details',
  templateUrl: './new-salesorder-invoice-details.component.html',
  styleUrls: ['./new-salesorder-invoice-details.component.scss'],
})
export class NewSalesorderInvoiceDetailsComponent implements OnChanges {
  static requiredValidator = Validators.required.bind(null);
  static emailValidator = Validators.email.bind(null);

  @Input() invoiceDetails!: FormGroup<InvoiceDetailsForm>;
  @Input() invoiceEmailAddress!: string;

  invoiceAddress: Address = {
    type: '',
    companyName: '',
    firstName: '',
    lastName: '',
    address: '',
    postalCode: '',
    city: '',
    countryCode: '',
    nightShipping: false,
  };

  get valid(): boolean {
    return !!this.invoiceDetails.get('emailAddress')?.valid;
  }

  static createInvoiceDetails(fb: FormBuilder, invoiceEmailAddress: string): FormGroup<InvoiceDetailsForm> {
    return fb.group<InvoiceDetailsForm>({
      emailAddress: new FormControl<string>(invoiceEmailAddress, {
        nonNullable: true,
        validators: [this.requiredValidator, this.emailValidator],
      }),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const change = changes.invoiceEmailAddress;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (change === undefined) {
      return;
    }
    if (!change.isFirstChange()) {
      const newEmail = change.currentValue as string;
      this.invoiceDetails.controls.emailAddress.patchValue(newEmail);
    }
  }

  getEmailAddress(): string {
    return this.invoiceDetails.controls.emailAddress.value;
  }
}
